import * as React from "react";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1000,
        color: "#fff"
    }
}));

const SimpleBackdrop = ({ isOpen = false, handleClose }) => {
    const classes = useStyles();

    return (
        <Backdrop
            className={classes.backdrop}
            open={isOpen}
            onClick={handleClose}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};

export default SimpleBackdrop;
